/** 成本议价单展示辅助 */

import { fixedUi } from '@/i18n/fixedUi';
import {
  DISCUSS_STATUS_LABELS,
  DISCUSS_TYPE_LABELS,
} from '@/shein-platform/constants/sheinApiCatalog';

export function discussStatusLabel(code) {
  if (code === undefined || code === null || code === '') return '—';
  const known = DISCUSS_STATUS_LABELS[code] || DISCUSS_STATUS_LABELS[Number(code)];
  if (known) return fixedUi(known);
  return String(code);
}

export function discussTypeLabel(code) {
  if (code === undefined || code === null || code === '') return '—';
  const known = DISCUSS_TYPE_LABELS[code] || DISCUSS_TYPE_LABELS[Number(code)];
  if (known) return fixedUi(known);
  return String(code);
}

export function discussStatusModifier(code) {
  const n = Number(code);
  if (n === 1) return 'pending';
  if (n === 2) return 'pending';
  if (n === 3 || n === 5) return 'success';
  if (n === 4 || n === 6) return 'failed';
  return 'pending';
}

export function normalizeDiscussImageUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return '';
  if (raw.startsWith('//')) return `https:${raw}`;
  return raw;
}

export function extractDiscussList(info) {
  if (!info) return [];
  if (Array.isArray(info)) return info;
  if (Array.isArray(info.data)) return info.data;
  if (Array.isArray(info.list)) return info.list;
  return [];
}

export function extractDiscussTotal(info, fallback = 0) {
  if (!info || typeof info !== 'object') return fallback;
  const n = Number(info.count ?? info.total ?? info.totalCount);
  return Number.isFinite(n) ? n : fallback;
}

/** 取 SKU 最新一轮商家报价（serialNumber 最大） */
export function latestCostHistory(sku) {
  const histories = Array.isArray(sku?.costPriceHistories) ? sku.costPriceHistories : [];
  if (!histories.length) return null;
  return histories.reduce((best, cur) => {
    if (!best) return cur;
    return Number(cur?.serialNumber) >= Number(best?.serialNumber) ? cur : best;
  }, null);
}

export function formatCostMoney(amount, currency) {
  if (amount === undefined || amount === null || amount === '') return '—';
  const cur = currency ? `${currency} ` : '';
  return `${cur}${amount}`;
}

/** 商家最新报价：优先 costPriceHistories 中 serialNumber 最大的一轮；否则回退 latestCostPrice */
export function formatSkuQuoteMoney(sku) {
  const last = latestCostHistory(sku);
  if (last && last.costPrice !== undefined && last.costPrice !== null && last.costPrice !== '') {
    return formatCostMoney(last.costPrice, last.currency);
  }
  if (sku?.latestCostPrice !== undefined && sku?.latestCostPrice !== null && sku?.latestCostPrice !== '') {
    return formatCostMoney(sku.latestCostPrice, last?.currency || sku?.suggestCostCurrency);
  }
  return '—';
}

/** 平台建议价 */
export function formatSkuSuggestMoney(sku) {
  return formatCostMoney(sku?.suggestCostPrice, sku?.suggestCostCurrency);
}

/** 多 SKU 时只展示最后一个 SKU 的价格（列表不拼接多个规格） */
export function formatSkuPricesSummary(skus, formatter) {
  const list = Array.isArray(skus) ? skus : [];
  if (!list.length) return '—';
  return formatter(list[list.length - 1]);
}
